exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pageContentWrapper__src-pages-UserList-styles__1iW4R {\n\tpadding-bottom: 100px;\n}\n\n.buttonRow__src-pages-UserList-styles__3M6vI {\n\tmargin-top: 10px;\n}", "", {"version":3,"sources":["/home/ubuntu/custom_apps_instances/digitalenterprises/temp/relevant-yield/relevant-frontend/src/pages/UserList/styles.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB;;AAED;CACC,iBAAiB;CACjB","file":"styles.css","sourcesContent":[".pageContentWrapper {\n\tpadding-bottom: 100px;\n}\n\n.buttonRow {\n\tmargin-top: 10px;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"pageContentWrapper": "pageContentWrapper__src-pages-UserList-styles__1iW4R",
	"buttonRow": "buttonRow__src-pages-UserList-styles__3M6vI"
};